import { render } from "./EnbWhatsapp.vue?vue&type=template&id=07112278&scoped=true"
import script from "./EnbWhatsapp.vue?vue&type=script&lang=js"
export * from "./EnbWhatsapp.vue?vue&type=script&lang=js"

import "./EnbWhatsapp.vue?vue&type=style&index=0&id=07112278&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07112278"]])

export default __exports__